const dev = {
	API_ENDPOINT_URL: '',
	PROFILE: 'DEV',
	SITE_URL: 'http://localhost:3011/',
};

const beta = {
	API_ENDPOINT_URL: '',
	PROFILE: 'BETA',
	SITE_URL: process.env.REACT_APP_SITE_URL || 'http://13.125.93.40/',
};

// TODO: REAL
const prod = {
    API_ENDPOINT_URL: process.env.REACT_APP_API_URL || '',
    PROFILE: 'PROD',
    SITE_URL: process.env.REACT_APP_SITE_URL || 'https://yesmunja.com/',
}

const getEnv = () => {
	switch (process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV || 'production') {
		case 'development':
			return dev
		case 'staging':
		case 'beta':
			return beta
		case 'production':
			return prod
		default:
			break;
	}
}

export const env = getEnv()
